import React from "react";
import { PeekGrid, PeekStack, PeekTypography, useTheme } from "@piiqtechnologies/ui-components";
import { getScoreColorHex } from "src/utils/utils";
import { UnderlinedTooltip } from "@components/common/underlined-tooltip";
export const ResultColumn = ({ xs, name, Icon, color, coloredRow = true, isLightIcon = false, fontWeight, tooltip, iconSize = 14, textAlign = "center", backgroundColor, ellipsis = false, }) => {
    const theme = useTheme();
    const highlightStyles = backgroundColor
        ? {
            backgroundColor,
            borderRadius: theme.spacing(1),
            maxWidth: "90%",
            placeSelf: "center",
            padding: 20,
            margin: 20 * -1,
            width: "100%",
        }
        : undefined;
    const resolvedColor = getScoreColorHex(name);
    const ellipsisStyles = ellipsis
        ? {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
        }
        : undefined;
    const isPrimitiveName = typeof name === "string" || typeof name === "number" || typeof name === "boolean";
    if (!Icon) {
        return (React.createElement(PeekGrid, { item: true, xs: xs, sx: ellipsis ? { overflow: "hidden", pr: 1 } : undefined },
            React.createElement(PeekStack, { direction: "row", alignItems: "center", justifyContent: textAlign, gap: 0.5, style: highlightStyles }, tooltip ? (React.createElement(UnderlinedTooltip, { tooltip: tooltip, placement: "top-start", typographyProps: {
                    textAlign,
                    fontWeight: fontWeight || theme.typography.fontWeightRegular,
                    color: coloredRow ? resolvedColor : theme.palette.primary.dark,
                }, sx: ellipsisStyles }, name)) : isPrimitiveName ? (React.createElement(PeekTypography, { textAlign: textAlign, fontWeight: fontWeight || theme.typography.fontWeightRegular, color: coloredRow ? resolvedColor : theme.palette.primary.dark, sx: ellipsisStyles }, name)) : (name))));
    }
    return (React.createElement(PeekGrid, { item: true, xs: xs, sx: ellipsis ? { overflow: "hidden", pr: 1 } : undefined },
        React.createElement(PeekStack, { direction: "row", alignItems: "center", justifyContent: textAlign, gap: 0.5, style: highlightStyles },
            Icon && (React.createElement(PeekStack, { sx: { opacity: isLightIcon ? 0.5 : 1 } },
                React.createElement(Icon, { width: iconSize, height: iconSize, style: { display: "inline-block" } }))),
            isPrimitiveName ? (React.createElement(PeekTypography, { textAlign: textAlign, fontWeight: fontWeight || theme.typography.fontWeightRegular, color: coloredRow ? resolvedColor : theme.palette.primary.dark, sx: ellipsisStyles }, name)) : (name))));
};
export default ResultColumn;
